var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 12.4999V14.9999H4.99967V12.4999H3.33301V14.9999C3.33301 15.9166 4.08301 16.6666 4.99967 16.6666H14.9997C15.9163 16.6666 16.6663 15.9166 16.6663 14.9999V12.4999H14.9997ZM14.1663 9.16658L12.9913 7.99159L10.833 10.1416V3.33325H9.16634V10.1416L7.00801 7.99159L5.83301 9.16658L9.99967 13.3333L14.1663 9.16658Z",
    fill: "#1513C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillDownload);
export default __webpack_public_path__ + "static/media/BillDownload.0f8f9fd9731bad738e75fd5ed45aa61a.svg";
export { ForwardRef as ReactComponent };